export enum DataPointStaticType {
  assignedTo,
  workflowStepCompleter,
  allWorkflowSteps,
  allStatuses,
  submittedOn,
  completedOn,
  stepStartedOn,
  stepCompletedOn,
  numberOfSubmissions,
  createdOn,
  lastUpdatedOn,
  numberOfRecords,
  stepDuration,
}

export const StaticFormDataPoints = [
  DataPointStaticType.assignedTo,
  DataPointStaticType.workflowStepCompleter,
  DataPointStaticType.allWorkflowSteps,
  DataPointStaticType.allStatuses,
  DataPointStaticType.submittedOn,
  DataPointStaticType.completedOn,
  DataPointStaticType.stepStartedOn,
  DataPointStaticType.stepCompletedOn,
  DataPointStaticType.stepDuration,
]

export const StaticObjectModelDataPoints = [
  DataPointStaticType.createdOn,
  DataPointStaticType.lastUpdatedOn,
  DataPointStaticType.numberOfRecords,
]

export const StaticFormWorkflowStepPoints = [
  DataPointStaticType.stepStartedOn,
  DataPointStaticType.stepCompletedOn,
  DataPointStaticType.completedOn,
  DataPointStaticType.workflowStepCompleter,
]

export const StaticDataPoints = [
  ...StaticFormDataPoints,
  ...StaticObjectModelDataPoints,
]

export const StaticDateDataPoints = [
  DataPointStaticType.createdOn,
  DataPointStaticType.lastUpdatedOn,
  DataPointStaticType.submittedOn,
  DataPointStaticType.completedOn,
  DataPointStaticType.stepStartedOn,
  DataPointStaticType.stepCompletedOn,
]

export const StaticTimeUnitDataPoints = [
  DataPointStaticType.stepDuration,
]

export const StaticNumericDataPoints = [
  DataPointStaticType.numberOfRecords,
  DataPointStaticType.numberOfSubmissions,
  DataPointStaticType.stepDuration,
]

export const StaticUserDataPoints = [
  DataPointStaticType.assignedTo,
  DataPointStaticType.workflowStepCompleter,
]

export const StaticTextDataPoints = [
  DataPointStaticType.allStatuses,
  DataPointStaticType.allWorkflowSteps,
]

export const StaticOptionDataPoints = [
  DataPointStaticType.allWorkflowSteps,
]

export const StaticDataPointLabels = {
  [DataPointStaticType.allStatuses]: 'static_all_statuses',
  [DataPointStaticType.assignedTo]: 'static_assigned_to',
  [DataPointStaticType.workflowStepCompleter]: 'static_workflow_step_completer',
  [DataPointStaticType.allWorkflowSteps]: 'static_all_workflow_steps',
  [DataPointStaticType.submittedOn]: 'static_submitted_on',
  [DataPointStaticType.completedOn]: 'static_completed_on',
  [DataPointStaticType.stepStartedOn]: 'static_step_started_on',
  [DataPointStaticType.stepCompletedOn]: 'static_step_completed_on',
  [DataPointStaticType.createdOn]: 'static_created_on',
  [DataPointStaticType.lastUpdatedOn]: 'static_last_updated_on',
  [DataPointStaticType.numberOfRecords]: 'static_number_of_records',
  [DataPointStaticType.numberOfSubmissions]: 'static_number_of_submissions',
  [DataPointStaticType.stepDuration]: 'static_step_duration',
}